'use strict';

module.exports = {
    AWS_S3: 'AWS_S3',
    S3C: 'S3C',
    ON_PREM: 'ON_PREM'
};